// extracted by mini-css-extract-plugin
export default {"container":"Video-module__container-huLyut","overlay":"Video-module__overlay-zIivI1","actionIcon":"Video-module__actionIcon-Ov0WQP","video":"Video-module__video-CAr0VL"};